export default {
  header: {
    title: '施工项目财务管理系统',
    logOut: '退出'
  },
  page: {
    register: {
      title: '注册',
      submit: '注册',
      other: '使用已有账户登录'
    }
  },
  navigation: {
    proj: {
      project: '工程管理',
      rsproj: '项目管理',
      projUser: '结算人管理',
      ctrAcct: '合同核算主体管理',
      rspCtrAcct: '合同核算主体管理New',
      settleUser: '结算人管理New',
      rspProject: '项目管理New'
    }
  },
  common: {
    toolBar: { // 操作
      addSave: '添加',
      updateSave: '保存',
      buildProj: '构建项目',
      buildDemoProj: '构建示例项目',
      nextStep: '下一步',
      previous: '上一步',
      nextMth: '下一月',
      prevMth: '上一月',
      nextPage: '下一页',
      prevPage: '上一页',
      prevRecord: '上一条',
      nextRecord: '下一条',
      checkedAndNext: '审核通过并显示下一条',
      checked: '审核通过',
      printBtn: '打印',
      exportBtn: '导出',
      close: '关闭',
      add: '新增',
      reset: '重置',
      back: '返回',
      commit: '提交',
      delete: '删除',
      jump: '跳转',
      confirm: '确定',
      loading: '加载中...',
      selectAll: '全选',
      empty: '清空',
      edit: '修改',
      save: '保存',
      cancel: '取消',
      refresh: '刷新',
      exit: '退出',
      finish: '完成',
      feeSumBtn: '费用类别统计',
      paymentSumBtn: '支付方式统计',
      opStatBtn: '经营状况表',
      fundStatBtn: '资金状况表',
      accountantTrans: '会计凭证',
      settleInvoice: '成本票台账',
      statistic: '汇总统计表',
      projMthRpt: '月报列表',
      accountantFlowTransListBtn: '会计日记账表',
      cashierFlowTransListBtn: '出纳日记账表',
      cashierFlowEntityMgmtBtn: '管理结算人',
      END_PROP: ''
    },
    commonVar: {
      projId: '项目',
      entityId: '结算人',
      costColId: '成本栏种类',
      seq: '序列',
      costColIdRefNotice: '请先选择\'成本栏种类\'',
      levelOneIdRefNotice: '请先选择\'一级分类\'',
      loadingSuccess: '登录成功,跳转中',
      downloadFileStatus: {
        WAITING: '待处理',
        IN_DEV: '处理中',
        DONE: '完成',
        FAILED: '失败'
      },
      download: '下载',
      exportDttm: '导出时间',
      hasAddedToQueue: '已加入处理队列',
      plsTypeInQuery: '请输入过滤条件',
      entityMenuTree: '选择需要导出的结算人/统计表',
      selectedTreePreview: '导出预览',
      downloadFileList: '最近下载列表',
      custom: '自定义',
      downloadItemType: '导出条目选择',
      editDone: '完成编辑',
      checkDone: '完成审核',
      updatedActionList: {
        ADD: '增',
        UPDATE: '改',
        REMOVE: '删'
      },
      refreshListNotice: '手动查询/刷新列表, 以获取完整数据',
      prefixPH: '请输入',
      suffixValidation: '必填',
      transIndexMissing: '凭证索引不完整',
      checked: '已审核',
      unChecked: '未审核',
      checkedPass: '审核通过',
      checkedFail: '审核不通过',
      passed: '已通过',
      unPassed: '未通过',
      all: '全部',
      allOrClear: '全选/清除',
      colIn: '资金总收入栏',
      colOut: '资金总支出栏',
      subTotal: '小计',
      total: '合计',
      price: '单价',
      action: '操作',
      actionInfo: '详情',
      actionSqlInfo: 'SQL详情',
      actionHistInfo: '历史',
      view: '查看',
      more: '更多',
      actionEdit: '编辑',
      actionAdd: '添加',
      actionCopy: '复制',
      actionCancel: '取消',
      actionSave: '保存',
      actionDelete: '删除',
      actionGoOn: '继续',
      completeInfo: '完整信息',
      settleDtNoticePrefix: '结算日为',
      fixedHeader: '表格滚动',
      updateSuccess: '修改成功',
      notice: '提示',
      noticeCopySuccess: '已经复制到剪贴板',
      noticeContent: '确认删除这条记录',
      noticeBuildDemoProj: '确定要在这个项目中新增示例结支付方式、算人、凭证、发票等信息?',
      noticeActionContent: '确认要执行',
      noticeCreateNewCtrAcct: '确定新增核算主体',
      noticeFinishReport: '报表完成后, 当月报表相关的数据将被禁止修改',
      noticeResumeReport: '开启"重新制表", 当月报表相关的数据将被允许修改',
      noticeReportDone: '报表已经完成, 禁止修改相关的数据',
      noticeVersionNoDiff: '系统已升级, 请刷新页面获取最新版本!',
      connectionFailedAlert: '服务器连接异常或登录超时, 请尝试刷新页面或重新登录!',
      connectionResumeAlert: '服务器连接恢复!',
      requiredFieldContent: '请输入必填项',
      requiredFieldFundStatEntity: '请选择费用类别',
      docIndexTitle: '设置凭证索引',
      docMth: '索引月份',
      docIndex: '索引序列',
      allowDuplicate: '允许重复',
      reaskNewDocIndex: '获取当月最新',
      editDocIndexNotePrefix: '将凭证索引',
      editDocIndexNoteChange: '改为',
      editDocIndexNoteNoChange: '（没有变化）',
      sum: '共计',
      max: '最大值',
      isDuplicateMonthIndex: '（存在重复索引！）',
      cancelCurModifyRowAlert: '请先取消正在修改的行记录!',
      clickToMoreInfo: '点击查看详情',
      settleInvoiceTitle: '成本票台账',
      feeSettleTransListTitle: '成本费用明细',
      findInvListByDocIndex: '查找凭证索引相关的发票',
      findSettleTransListByDocIndex: '在结算人信息登记表中展示相关凭证',
      autoCalculation: '自动计算',
      removeFromList: '数据已被移除列表',
      addToListButtom: '数据已被添加在列表末行',
      refDataAuditTitle: '相关数据修改列表',
      refSysLogSqlTitle: '相关SQL执行列表',
      delSuccess: '删除成功',
      failed: '失败',
      insertSuccess: '新增成功',
      buildProjSuccess: '项目构建成功',
      msgDataAlreadyUsed: '数据已被使用',
      addTransFirstly: '凭证添加成功后, 再修改发票信息',
      selectMonth: '月份',
      selectMonthPH: '选择月份',
      selectStartDt: '开始日期',
      selectStartDtPH: '选择开始日期',
      selectEndDt: '结束日期',
      selectEndDtPH: '选择结束日期',
      status: '状态',
      statusPH: '请选择状态',
      entityStatus: '实体状态',
      entityStatusPH: '请选择实体状态',
      ctrAcctType: '主体类型',
      ctrAcctTypePH: '请选择主体类型',
      defCtrAcctType: '默认主体类型',
      defCtrAcctTypePH: '请选择默认主体类型',
      compId: '所属公司',
      compIdPH: '请选择公司',
      subsysPH: '请选择板块',
      indUsed: '使用状况',
      crtBy: '创建者',
      crtOn: '创建时间',
      updBy: '修改者',
      updOn: '修改时间',
      addOn: '添加时间',
      searchInfo: '数据查询',
      reportInfo: '报表信息',
      baseInfo: '基本信息',
      afterEntityDone: '完工后显示',
      fundStatEntityIdError: '费用类别不正确',
      naValue: '--未设置--',
      info: {
        dt: '日期',
        dtPH: '请输入日期',
        userId: '操作人',
        userIdPH: '请输入操作人'
      },
      // userRoleMap: {
      //   admin: '系统管理员',
      //   COMP_ADMIN_GRP: '管理员',
      //   PROJ_ACCOUNTANT_GRP: '会计',
      //   PROJ_CASHIER_GRP: '出纳',
      //   COMP_ADV_VIEW_GRP: '高级观察员',
      //   COMP_VIEW_GRP: '普通观察员'
      // },
      menuLabel: {
        PROJ: '项目列表',
        MENU: '系统菜单'
      },
      successList: {
        success: '成功',
        failure: '失败'
      },
      projStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        PAUSE: '暂停',
        CANCEL: '取消',
        DONE: '结束'
      },
      indList: {
        Y: '是',
        N: '不是'
      },
      indUsedList: {
        Y: '已经使用',
        N: '未使用'
      },
      statusList: {
        A: '显示',
        I: '隐藏'
      },
      checkedList: {
        'true': '已审核',
        'false': '未审核'
      },
      checkedStatusList: {
        'F': '审核不通过',
        'P': '审核通过',
        'U': '未审核'
      },
      rptStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        DONE: '已完成'
      },
      paymentTypeList: {
        CASH: '现金支付',
        WITHHOLD: '代扣代付',
        TRANSFER: '转账支付'
      },
      invPaymentTypeList: {
        CASH: '现金',
        TRANSFER: '转账'
      },
      entityStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        PAUSE: '暂停',
        DONE: '已完工结算'
      },
      incomeTypeList: {
        PROJ_FUND: '工程款项',
        OTH_INCOME: '其它收入',
        PROJ_OUT_VAT: '工程款增值税销项',
        TRANSFER: '转账支付'
      },
      ctrAcctTypeList: {
        PM: '项目管理',
        PRI: '总承包',
        SND: '自营分包'
      },
      projUserRoleList: {
        SETTLE: '普通结算人',
        MGR: '项目负责人',
        TAB: '制表人'
      },
      settleStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        PAUSE: '暂停',
        DONE: '已完工结算'
      },
      transDtSearchTypeList: {
        ALL: '所有',
        MONTH: '按月查询',
        DT_SCOPE: '按指定日期范围'
      },
      transDt2SearchTypeList: {
        ALL: '所有',
        YEAR: '年份',
        MONTH: '月份',
        DT_SCOPE: '指定日期'
      },
      searchMonthTypeList: {
        CURRENT: '当月',
        TOTAL: '累计'
      },
      invTypeList: {
        SPECIAL: '专票',
        TAX: '普票',
        QUOTA: '定额票',
        BY_MACHINE: '机打票',
        E_INV: '电子票'
      },
      dateSearchMethodList: {
        ALL: '所有',
        MONTH: '按月查询',
        DT_SCOPE: '按指定日期范围',
        DATE_SCOPE: '按指定日期范围',
        PAUSE: '暂停',
        DONE: '已完工结算'
      },
      tableNo: {
        ONE: '一',
        TWO: '二',
        THREE: '三',
        FOUR: '四',
        FIVE: '五',
        SIX: '六',
        SEVEN: '七',
        EIGHT: '八',
        NINE: '九',
        TEN: '十'
      },
      numberMap: {
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六',
        '7': '七',
        '8': '八',
        '9': '九',
        '10': '十'
      },
      columnId: {
        settle: '001000',
        income: '002000',
        acctPay: '003000',
        acctReceive: '004000',
        acctCur: '005000'
      },
      columnName: {
        settle: '工程成本栏',
        income: '收入栏',
        acct: '资金栏',
        acctPay: '应付账款栏',
        acctReceive: '应收帐款栏',
        acctCur: '往来帐款栏'
      },
      columnNameUpper: {
        SETTLE: '工程成本栏',
        INCOME: '收入栏',
        ACCT_PAY: '应付账款栏',
        ACCT_RECEIVE: '应收帐款栏',
        ACCT_CUR: '往来帐款栏'
        // ,
        // INVEST_FIN: '投融资款'
      },
      invCertStatusList: {
        IN_DEV: '未完成',
        DONE: '完成'
      },
      tableActionList: {
        INSERT: '新增',
        UPDATE: '修改',
        DELETE: '删除',
        REMOVE: '标记删除'
        // {value: '', descr: '新增', status: 'A'},
        // {value: '', descr: '', status: 'A'},
        // {value: '', descr: '', status: 'A'}
      },
      rptStatus: {
        IN_DEV: '进行中',
        CHECKING: '待审核',
        MODIFYING: '待修改',
        DONE: '完成'
      },
      rptActionType: {
        CREATE: '创建月报',
        COMMENT: '添加备注',
        SUBMIT: '提交待审',
        REJECT: '审核不通过',
        APPROVAL: '审核通过',
        REOPEN: '反结账'
      },
      rptMsgInfo: {
        history: '备注历史记录',
        operationTime: '操作时间',
        historyOperation: '历史操作',
        checkComment: '审核备注'
      },
      dtSearchField: {
        searchType: '查询方式',
        searchYear: '年份',
        searchMonth: '月份',
        searchDtScope: '日期范围',
        searchYearType: '年查询类型',
        searchMonthType: '月查询类型',
        startDt: '起始日期',
        endDt: '截止日期'
      }
    },
    queryBar: {
      searchBT: '查询',
      projSearchBT: '查找项目'
    }
  },
  component: {
    proj: {
      feeSumCard: {
        cardTitle: '费用类别统计',
        // feeSum: '合计',
        number: '#',
        feeName: '费用名称',
        feeAmt: '金额'
      },
      paymentSumCard: {
        cardTitle: '支付方式统计',
        paymentName: '支付方式',
        paymentAmt: '金额'
      }
    }
  },
  module: {
    profile: {
      userSecurity: {
        aliasName: '修改密码',
        info: {
          userName: '用户名',
          oldPassword: '原密码',
          newPassword: '新密码',
          confirmPassword: '确认密码',
          mobile: '移动电话',
          code: '验证码'
        },
        message: {
          pwdLengthValidation: '密码必须在6-16位之间',
          confirmPwdValidation: '两次密码不一致',
          pwdChangedValidation: '新密码不能和原密码相同',
          pwdChangedSuccessMsg: '密码更新成功，请重新登录。'
        }
      }
    },
    audit: {
      actiontrail: {
        searchInfo: {
          searchProjId: '项目',
          searchProjIdPH: '请输入项目',
          searchEntityId: '结算人',
          searchEntityIdPH: '请输入结算人',
          searchIndDataChange: '增删改操作',
          searchIndDataChangePH: '请输入选项值',
          searchSuccess: '请求成功',
          searchSuccessPH: '请输入选项值',
          searchSubsysKey: '板块',
          searchSubsysKeyPH: '请输入板块',
          searchModuleKey: '模块',
          searchModuleKeyPH: '请输入模块',
          searchFnKey: '功能',
          searchFnKeyPH: '请输入功能',
          searchActionKey: '接口',
          searchActionKeyPH: '请输入接口',
          // searchFundStatEntityIdList: '费用类别',
          colGroup: '收入/支出栏'
        },
        searchValidateInfo: {
          // searchTypeRequired: '查询方式必填',
          // searchCtrAcctIdRequired: '核算主体必填'
        },
        info: {
          logUid: '日志UID',
          userId: '操作人',
          projId: '项目',
          entityId: '结算人',
          subsysKey: '板块',
          moduleKey: '模块',
          fnKey: '功能',
          actionKey: '接口',
          success: '结果',
          requestUri: '访问地址',
          indDataChange: '增删改操作',
          // startAndEndTime: '开始/结束时间',
          startAndTotalTime: '发生时间', //  / 耗时
          startTime: '开始时间',
          endTime: '结束时间',
          crtOn: '日志记录时间'
        }
      },
      dataaudit: {
        info: {
          logUid: '日志UID',
          userId: '操作人',
          dataAction: '操作类型', // INSERT, UPDATE, DELETE
          indChanged: '是否变化', // 数据是否真的发生变化
          // refFieldMap: ''
          changeList: '数据变化（字段名: 初始值 -> 设定值）',
          startAndTotalTime: '发生时间 / 耗时',
          startTime: '开始时间',
          endTime: '结束时间',
          crtOn: '日志记录时间',
          moduleAlias: '数据表'
        }
      },
      syslogsql: {
        info: {
          logUid: '日志UID',
          userId: '操作人',
          sqlBody: 'SQL语句',
          sqlParam: '参数', // 数据是否真的发生变化
          startAndTotalTime: '发生时间 / 耗时',
          startTime: '开始时间',
          // endTime: '结束时间',
          crtOn: '日志记录时间'
        }
      }
    },
    proj: {
      pd: {
        pdTypeLevelOne: {
          info: {
            levelOneName: '一级分类名称'
          }
        },
        pdName: {
          info: {
            levelOneId: '一级分类',
            productName: '品名'
          }
        },
        rspProjSettleMaterial: {
          info: {
            levelOneId: '一级分类',
            pdTransDt: '日期',
            settleDt: '结算周期', // 冗余字段的名称(非数据库字段)
            settleStartDt: '起始日期',
            settleEndDt: '截止日期',
            deliveryNo: '送货单号',
            stockInNo: '入库单号',
            productId: '品名',
            spec: '规格',
            unit: '单位',
            num: '数量',
            priceWithTax: '含税单价',
            vatRate: '增值税税率',
            priceWithoutTax: '离税单价', // 冗余字段的名称(非数据库字段)
            withTaxAmt: '价税合计', // 冗余字段的名称(非数据库字段)
            taxAmt: '税额', // 冗余字段的名称(非数据库字段)
            withoutTaxAmt: '金额', // 冗余字段的名称(非数据库字段)
            deductionAmt: '扣款金额',
            brand: '品牌',
            inquiryDt: '询价时间',
            remarks: '备注'
          }
        },
        rspProjSettleLabour: {
          info: {
            levelOneId: '一级分类',
            pdTransDt: '日期',
            settleDt: '结算周期', // 冗余字段的名称(非数据库字段)
            settleStartDt: '起始日期',
            settleEndDt: '截止日期',
            // deliveryNo: '送货单号',
            // stockInNo: '入库单号',
            productId: '品名',
            jobContent: '工作内容及要求',
            unit: '单位',
            num: '数量',
            priceWithTax: '含税单价', // 冗余字段的名称(非数据库字段)
            vatRate: '增值税税率',
            priceWithoutTax: '离税单价',
            withTaxAmt: '价税合计', // 冗余字段的名称(非数据库字段)
            taxAmt: '税额', // 冗余字段的名称(非数据库字段)
            withoutTaxAmt: '金额', // 冗余字段的名称(非数据库字段)
            deductionAmt: '扣款金额',
            // brand: '品牌',
            inquiryDt: '询价时间',
            remarks: '备注'
          }
        },
        rspProjSettleSubcontract: {
          info: {
            levelOneId: '一级分类',
            pdTransDt: '日期',
            settleDt: '结算周期', // 冗余字段的名称(非数据库字段)
            settleStartDt: '起始日期',
            settleEndDt: '截止日期',
            // deliveryNo: '送货单号',
            // stockInNo: '入库单号',
            productId: '品名',
            jobContent: '工作内容及要求',
            unit: '单位',
            num: '数量',
            priceWithTax: '含税单价',
            vatRate: '增值税税率',
            priceWithoutTax: '离税单价', // 冗余字段的名称(非数据库字段)
            withTaxAmt: '价税合计', // 冗余字段的名称(非数据库字段)
            taxAmt: '税额', // 冗余字段的名称(非数据库字段)
            withoutTaxAmt: '金额', // 冗余字段的名称(非数据库字段)
            deductionAmt: '扣款金额',
            brand: '品牌',
            inquiryDt: '询价时间',
            remarks: '备注'
          }
        },
        rspProjSettleLease: {
          info: {
            levelOneId: '一级分类',
            pdTransDt: '日期',
            settleDt: '结算周期', // 冗余字段的名称(非数据库字段)
            settleStartDt: '起始日期',
            settleEndDt: '截止日期',
            // deliveryNo: '送货单号',
            // stockInNo: '入库单号',
            productId: '品名',
            // jobContent: '工作内容及要求',
            spec: '规格',
            unit: '单位',
            leaseDt: '租赁日期',
            num: '数量', // 冗余字段的名称(非数据库字段)
            inNum: '进场数量',
            outNum: '出场数量',
            leaseDuration: '租赁时长', // (天/月/年)
            priceWithoutTax: '离税单价',
            priceTax: '税金单价',
            priceWithTax: '含税单价',
            vatRate: '增值税税率',
            withoutTaxAmt: '金额',
            taxAmt: '税额',
            withTaxAmt: '价税合计',
            deductionAmt: '扣款金额',
            // brand: '品牌',
            inquiryDt: '询价时间',
            remarks: '备注'
          }
        }
      },
      rpt: {
        projmthrpt: {
          info: {
            rptId: '月报表ID',
            projId: '项目',
            compId: '公司',
            rptMth: '报表月份',
            rptStatus: '报表状态',
            firstSubmitDttm: '首次提交时间',
            lastSubmitDttm: '最后提交时间',
            lastRejectDttm: '拒签时间',
            lastApprovalDttm: '完成时间',
            lastReopenDttm: '反结账时间',
            remarks: '备注'
          },
          pageName: {
            indexPage: '项目月报列表'
          }
        }
      },
      project: {
        info: {
          lastRpt: '最近月报',
          lastUnDoneRpt: '待完成',
          lastDoneRpt: '完成',
          projName: '项目名称',
          projNamePH: '请输入项目名称',
          projDesc: '描述',
          projDescPH: '请输入项目描述',
          defSurchargeTaxRate: '附加税税率',
          defSurchargeTaxRatePH: '请输入附加税税率',
          projectPercent: '公司占比',
          projectPercentPH: '请输入公司占比',
          projSettleDtNum: '每月结算日',
          projSettleDtNumPH: '请输入每月结算日',
          projMgr: '项目经理',
          projMgrPH: '请输入项目经理',
          projStatus: '项目进度',
          projStatusPH: '请选择项目进度',
          startDt: '开始日期',
          startDtPH: '请输入开始日期',
          endDt: '结束日期',
          endDtPH: '请输入结束日期',
          // assignTo: '执行者',
          // assignToPH: '请选择执行者',
          // assignOn: '分配时间',
          // modalAssignTitle: '设置项目资金数据的唯一编辑者',
          modalProjSettleDtNumTitle: '设置每月结算日',
          modalDefSurchargeTaxRateTitle: '设置附加税税率',
          modalProjectPercentTitle: '设置公司占比',
          accountant: '会计执行人',
          accountantPH: '请选择会计执行人',
          accountantOn: '分配时间',
          modalAccountantTitle: '设置项目的唯一会计执行人',
          cashier: '出纳执行人',
          cashierPH: '请选择出纳执行人',
          cashierOn: '分配时间',
          modalCashierTitle: '设置项目的唯一出纳执行人',
          checker: '审核执行人',
          checkerPH: '请选择审核执行人',
          checkerOn: '分配时间',
          modalCheckerTitle: '设置项目的唯一审核执行人',
          othUserIdList: '高级查看组',
          othUserIdListPH: '请选择高级查看组成员',
          modalOthUserTitle: '设置项目的高级查看组成员',
          costCtrlUserIdList: '成控组',
          costCtrlUserIdListPH: '请选择成控组成员',
          modalCostCtrlUserTitle: '设置项目的成控组成员',
          othUserIdListCanBeAddedLater: '新增项目成功后，可添加项目的审核人高级查看组、成控组成员'
        },
        button: {
          addBtn: '新增项目'
        },
        listButton: {
          confProjectBtn: '配置',
          entryStatisticBtn: '统计表'
        },
        pageName: {
          addPage: '新增项目',
          editPage: '编辑项目',
          viewPage: '项目详情',
          confPage: '项目配置',
          projectDownloadPage: '报表下载',
          statisticPage: '汇总统计表',
          opStatPage: '月经营状况表',
          fundStatPage: '月资金状况表',
          settleInvListPage: '成本票台账',
          accountantFlowTransListPage: '会计日记账表',
          cashierFlowTransListPage: '出纳日记账表',
          accountantTransPage: '会计凭证',
          settlePage: '结算人信息登记表-工程成本栏',
          incomePage: '结算人信息登记表-收入栏',
          acctPayPage: '资金结算表-应付账款栏',
          acctReceivePage: '资金结算表-应收账款栏',
          acctCurPage: '资金结算表-往来帐款栏'
        },
        validateInfo: {
          compIdRequired: '公司名称必填',
          projNameRequired: '项目名称必填',
          projStatusRequired: '项目进度必填',
          statusRequired: '状态必填'
        },
        addProjBtn: '新增项目',
        editProjSettleCollBtn: '栏目',
        confProjectBtn: '配置',
        confProjSettleUserBtn: '结算人',
        projName: '项目名称',
        projNamePH: '请输入项目名称',
        projDesc: '描述',
        projDescPH: '请输入项目描述',
        status: '状态',
        statusPH: '请选择状态',
        startDt: '开始日期',
        startDtPH: '请输入开始日期',
        endDt: '结束日期',
        endDtPH: '请输入结束日期',
        crtBy: '创建者',
        crtOn: '创建时间',
        updBy: '修改者',
        updOn: '修改时间',
        settleColl: {
          // collName: '栏目名称',
        //
        },
        step: {
          confProjCtrAcct: '核算主体',
          confProjSettleEntity: '工程成本栏',
          confProjIncomeEntity: '收入栏',
          confProjAcctPayEntity: '应付账款栏',
          confProjAcctReceiveEntity: '应收账款栏',
          confProjAcctCurEntity: '往来账款栏'
        },
        settleStep: {
          confProjSettleEntity: '结算人',
          confProjSettlePayment: '支付方式',
          confProjSettleProjMgr: '项目经理'
        },
        projctracct: {
          info: {
            ctrAcctId: '核算主体',
            ctrAcctIdPH: '请选择主体',
            type: '主体类型',
            typePH: '请选择类型'
          },
          validateInfo: {
            ctrAcctIdRequired: '核算主体必填',
            typeRequired: '主体类型必填',
            statusRequired: '状态必填'
          }
        },
        projsettleentity: {
          moduleAlias: '结算人-工程成本栏',
          info: {
            // 展示日志
            // colId: '类别',
            colType: '栏目',
            compId: '公司',
            entityId: 'ID',
            entityStatus: '进展',
            projId: '项目',
            seq: '序列',
            status: '状态',
            indDel: '标记删除',
            // ...
            entityName: '结算人',
            entityNamePH: '请输入结算人',
            entityDesc: '实体描述',
            entityDescPH: '请输入描述',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            costColId: '类别',
            costColIdPH: '请选择类别',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式',
            content: '事项内容',
            contentPH: '请输入事项内容',
            contractNo: '合同编号',
            contractNoPH: '请输入合同编号'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填',
            ctrAcctIdRequired: '核算主体必填',
            costColIdRequired: '类别必填'
          }
        },
        projsettlepayment: {
          info: {
            paymentName: '支付方式',
            paymentNamePH: '请输入支付方式',
            paymentDesc: '描述',
            paymentDescPH: '请输入描述',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            type: '支付类型',
            typePH: '请选择类型'
          },
          validateInfo: {
            paymentNameRequired: '支付方式必填',
            ctrAcctIdRequired: '核算主体必填',
            typeRequired: '支付类型必填'
          }
        },
        projincomeentity: {
          info: {
            entityName: '结算人',
            entityNamePH: '请输入结算人',
            entityDesc: '实体描述',
            entityDescPH: '请输入描述',
            type: '类别',
            typePH: '请选择类别',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            tgtCtrAcctId: '目标主体',
            tgtCtrAcctIdPH: '请选择目标主体',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式',
            content: '事项内容',
            contentPH: '请输入事项内容',
            contractNo: '合同编号',
            contractNoPH: '请输入合同编号'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填',
            typeRequired: '主体类型必填',
            ctrAcctIdRequired: '核算主体必填'
          }
        },
        projacctpayentity: {
          info: {
            entityName: '结算人',
            entityNamePH: '请输入结算人',
            entityDesc: '实体描述',
            entityDescPH: '请输入描述',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式',
            content: '事项内容',
            contentPH: '请输入事项内容',
            contractNo: '合同编号',
            contractNoPH: '请输入合同编号'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填',
            ctrAcctIdRequired: '核算主体必填'
          }
        },
        projacctreceiveentity: {
          info: {
            entityName: '结算人',
            entityNamePH: '请输入结算人',
            entityDesc: '实体描述',
            entityDescPH: '请输入描述',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            tgtCtrAcctId: '目标主体',
            tgtCtrAcctIdPH: '请选择目标主体',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式',
            content: '事项内容',
            contentPH: '请输入事项内容',
            contractNo: '合同编号',
            contractNoPH: '请输入合同编号'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填',
            ctrAcctIdRequired: '核算主体必填',
            tgtCtrAcctIdRequired: '目标主体必填'
          }
        },
        projacctcurentity: {
          info: {
            entityName: '结算人',
            entityNamePH: '请输入名称',
            entityDesc: '实体描述',
            entityDescPH: '请输入描述',
            ctrAcctId: '合同核算主体',
            ctrAcctIdPH: '请选择主体',
            tgtCtrAcctId: '目标主体',
            tgtCtrAcctIdPH: '请选择目标主体',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式',
            content: '事项内容',
            contentPH: '请输入事项内容',
            contractNo: '合同编号',
            contractNoPH: '请输入合同编号'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填',
            ctrAcctIdRequired: '核算主体必填',
            tgtCtrAcctIdRequired: '目标主体必填'
          }
        },
        opstat: {
          info: {
            settleDt: '报表截止日期',
            settleDtPH: '请输入报表截止日期',
            projMgr: '项目负责人',
            projMgrPH: '请输入项目负责人',
            rptEditor: '编制',
            rptEditorPH: '请输入编制',
            rptStatus: '报表状态',
            finishBy: '完成者',
            finishOn: '完成时间',
            //
            inTitle: '一、施工产值收入栏',
            outTitle: '二、成本总支出栏',
            storeTitle: '三、库存统计栏',
            targetTitle: '四、指标核算栏',
            balTitle: '资金盈余',
            tableNo: '序号',
            feeAmt: '金额（元）',
            amtPH: '请输入金额',
            checkedAmt: '核对值',
            checkedAmtPH: '请输入核对值',
            diffAmt: '差值',
            remarks: '编制说明',
            // 一、施工产值收入栏
            entityName: '费用名称',
            lastMthAmt: '上月累计（元）',
            curMthAmt: '当月（元）',
            balAmt: '余额累计（元）',
            // 二、成本总支出栏
            feeEntityName: '费用名称及分类',
            // 三、库存统计栏
            storeEntityName: '存货名称'
          }
        },
        accountantFlowTrans: {
          searchInfo: {
            searchCtrAcctId: '合同核算主体',
            searchFundStatEntityIdList: '费用类别',
            colGroup: '收入/支出栏'
          },
          searchValidateInfo: {
            searchTypeRequired: '查询方式必填',
            searchCtrAcctIdRequired: '核算主体必填'
          },
          info: {
            transDt: '日期',
            transSummary: '摘要',
            inAmt: '收入金额',
            outAmt: '支出金额',
            balAmt: '余额',
            colType: '栏目',
            entityId: '结算人',
            fundStatEntityId: '费用类别',
            paymentId: '支付方式',
            docIndex: '凭证索引',
            transRemarks: '备注'
          }
        },
        cashierFlowEntity: {
          pageName: {
            listPage: '管理结算人'
          },
          info: {
            entityName: '结算人',
            entityNamePH: '请输入结算人',
            entityDesc: '描述',
            entityDescPH: '请输入描述',
            entityContact: '联系方式',
            entityContactPH: '请输入联系方式'
          },
          validateInfo: {
            entityNameRequired: '核算主体必填'
          }
        },
        cashierFlowTrans: {
          fundStatCardTitle: '资金状况表',
          searchInfo: {
            searchCtrAcctId: '合同核算主体',
            searchFundStatEntityIdList: '费用类别',
            colGroup: '收入/支出栏',
            searchEntityId: '结算人',
            searchEntityIdPH: '请输入结算人',
            searchPaymentId: '支付方式',
            searchPaymentIdPH: '请输入支付方式'
          },
          searchValidateInfo: {
            searchTypeRequired: '查询方式必填',
            searchCtrAcctIdRequired: '核算主体必填',
            colGroupRequired: '收入/支出栏必填',
            searchFundStatEntityIdListRequired: '费用类别必填'
          },
          info: {
            transDt: '日期',
            transDtPH: '请输入日期',
            transSummary: '摘要',
            transSummaryPH: '请输入摘要',
            inAmt: '收入金额',
            inAmtPH: '请输入收入金额',
            outAmt: '支出金额',
            outAmtPH: '请输入支出金额',
            balAmt: '余额',
            colType: '栏目',
            entityId: '结算人',
            entityIdPH: '请选择结算人',
            fundStatEntityId: '费用类别',
            fundStatEntityIdPH: '请选择费用类别',
            paymentId: '支付方式',
            paymentIdPH: '请选择支付方式',
            transIndex: '凭证索引',
            transIndexPH: '请输入凭证索引',
            transRemarks: '备注',
            transRemarksPH: '请输入备注'
          },
          validateInfo: {
            transDtRequired: '日期必填',
            fundStatEntityIdRequired: '费用类别必填'
          }
        },
        fundstat: {
          info: {
            ctrAcctTitle: '资金状况表',
            inTitle: '资金总收入栏',
            outTitle: '资金总支出栏',
            balTitle: '资金盈余',
            pmBalTitle: '资金盈余',
            othTitle: '其他指标栏',
            tableNo: '序号',
            entityName: '费用名称',
            feeAmt: '累计（元）',
            checkedAmt: '比对值',
            checkedAmtPH: '请输入比对值',
            diffAmt: '差值',
            remarks: '编制说明（比对值为出纳值）'
          }
        }
      },
      projectUser: {
        info: {
          legalName: '用户姓名',
          legalNamePH: '请输入用户姓名',
          mobile: '电话号码',
          mobilePH: '请输入电话号码',
          position: '职务',
          status: '账号状态'
        },
        pageName: {
          viewPage: '用户详情'
        },
        validateInfo: {
          compIdRequired: '公司名称必填'
        }
      },
      projstatistic: {
        searchInfo: {
          searchEntityName: '（成本栏）结算人名称',
          searchEntityNamePH: '请输入结算人名称',
          searchType: '查询方式',
          searchTypePH: '请选择查询方式',
          searchMonth: '月份',
          searchMonthPH: '请选择月份',
          searchDtScope: '日期范围',
          searchDtScopePH: '请选择开始/结束日期',
          searchStartDt: '开始日期',
          searchStartDtPH: '请选择开始日期',
          searchEndDt: '结束日期',
          searchEndDtPH: '请选择结束日期',
          searchFeeId: '费用名称',
          searchFeeIdPH: '请选择费用名称',
          searchPaymentId: '支付方式',
          searchPaymentIdPH: '请选择支付方式',
          searchDocIndex: '凭证索引',
          searchDocIndexPH: '请选择凭证索引'
        },
        searchValidateInfo: {
          searchTypeRequired: '查询方式必填'
        },
        info: {
          tableNo: '编号',
          entityName: '结算人名称',
          entityNamePH: '请输入结算人',
          ctrAcctId: '合同核算主体',
          content: '事项内容',
          contractAmtSummary: '合同累计金额',
          //
          reimbSettl: '结算报销',
          reimbOutputSettlAmtSummary: '产值结算余额',
          reimbOfficialSettlAmtSummary: '正式结算金额',
          reimbTotalSettlAmtSummary: '结算累计金额',
          //
          payment: '支付',
          payPlanAmtSummary: '按合同比例应付金额',
          incomePayPlanAmtSummary: '按合同比例应收金额',
          payDebtAmtSummary: '借支、押金余额',
          payAmtSummary: '支付累计金额',
          unpaidAmtSummary: '应付未付金额',
          //
          invoice: '票据',
          invAmtSummary: '已提供',
          invSpreadSummary: '票据差额',
          //
          finalPayment: '完工支付信息',
          unpaidPaymentAmtSummary: '结算未付金额',
          entityStatus: '是否已完工结算',
          //
          fundEntityName: '款项名称',
          fundEntityNamePH: '请输入款项名称',
          //
          inAmtSummary: '收入金额',
          outAmtSummary: '支出金额',
          balAmtSummary: '余额',
          // 收入栏表格抬头文本特殊处理
          incomePayAmtSummary: '收款累计金额',
          incomeUnpaidAmtSummary: '应收未收金额',
          incomeUnpaidPaymentAmtSummary: '结算未收金额'
        },
        validateInfo: {
          entityNameRequired: '结算实体必填'
        }
      },
      accountantTrans: {
        info: {
          colType: '栏目',
          colTypePH: '请输入栏目',
          entityId: '结算人',
          entityIdPH: '请输入结算人',
          checked: '审核状态',
          checkedComment: '审核备注',
          checkedPH: '请输入审核状态'
        }
      },
      projsettletrans: {
        moduleAlias: '凭证-工程成本栏',
        info: {
          invId: '发票ID',
          transId: '凭证',
          projId: '项目',
          compId: '公司',
          entityId: '结算人',
          docMth: '索引月份',
          // docIndex: '索引序列',
          indDel: '标记删除',
          transDt: '日期',
          transDtPH: '请输入日期',
          transSummary: '摘要',
          transSummaryPH: '请输入摘要',
          contractAmt: '合同金额',
          contractAmtPH: '请输入合同金额',
          reimbSettl: '结算报销',
          feeId: '费用名称',
          feeIdPH: '请选择费用名称',
          reimbOutputSettlAmt: '产值结算金额',
          reimbOutputSettlAmtPH: '请输入产值结算金额',
          reimbOfficialSettlAmt: '正式结算金额',
          reimbOfficialSettlAmtPH: '请输入正式结算金额',
          reimbTotalSettlAmt: '结算总金额',
          reimbTotalSettlAmtPH: '请输入结算总金额',
          payment: '支付',
          payPlanAmt: '按合同比例应付金额',
          payPlanAmtPH: '请输入按合同比例应付金额',
          incomePayPlanAmt: '按合同比例应收金额',
          incomePayPlanAmtPH: '请输入按合同比例应收金额',
          payDebtAmt: '借支、押金金额',
          payDebtAmtPH: '请输入借支、押金金额',
          payAmt: '支付金额',
          payAmtPH: '请输入支付金额',
          incomePayAmt: '收款金额',
          incomePayAmtPH: '请输入收款金额',
          paymentId: '支付方式',
          paymentIdPH: '请选择支付方式',
          incomePaymentId: '收款方式',
          incomePaymentIdPH: '请选择收款方式',
          invAmt: '发票金额',
          invAmtPH: '请输入发票金额',
          docIndex: '凭证索引',
          docIndexPH: '请输入凭证索引',
          transRemarks: '备注',
          transRemarksPH: '请输入备注'
        },
        validateInfo: {
          transDtRequired: '日期必填',
          feeIdRequired: '费用名称必填',
          paymentIdRequired: '支付方式'
        }
      },
      projincometrans: {
        moduleAlias: '凭证-收入栏',
        info: {
          transDt: '日期',
          transDtPH: '请输入日期',
          transSummary: '摘要',
          transSummaryPH: '请输入摘要',
          contractAmt: '合同金额',
          contractAmtPH: '请输入合同金额',
          reimbSettl: '结算报销',
          feeId: '费用名称',
          feeIdPH: '请选择费用名称',
          reimbOutputSettlAmt: '产值结算金额',
          reimbOutputSettlAmtPH: '请输入产值结算金额',
          reimbOfficialSettlAmt: '正式结算金额',
          reimbOfficialSettlAmtPH: '请输入正式结算金额',
          reimbTotalSettlAmt: '结算总金额',
          reimbTotalSettlAmtPH: '请输入结算总金额',
          payment: '支付',
          payPlanAmt: '按合同比例应付金额',
          payPlanAmtPH: '请输入按合同比例应付金额',
          incomePayPlanAmt: '按合同比例应收金额',
          incomePayPlanAmtPH: '请输入按合同比例应收金额',
          payDebtAmt: '借支、押金金额',
          payDebtAmtPH: '请输入借支、押金金额',
          payAmt: '支付金额',
          payAmtPH: '请输入支付金额',
          incomePayAmt: '收款金额',
          incomePayAmtPH: '请输入收款金额',
          paymentId: '支付方式',
          paymentIdPH: '请选择支付方式',
          incomePaymentId: '收款方式',
          incomePaymentIdPH: '请选择收款方式',
          invAmt: '发票金额',
          invAmtPH: '请输入发票金额',
          docIndex: '凭证索引',
          docIndexPH: '请输入凭证索引',
          transRemarks: '备注',
          transRemarksPH: '请输入备注',
          checkedComment: '请输入审核备注'
        },
        validateInfo: {
          transDtRequired: '日期必填',
          feeIdRequired: '费用名称必填',
          paymentIdRequired: '支付方式'
        }
      },
      projsettleinvoice: {
        moduleAlias: '成本票台账',
        summary: {
          // infoDt: '时间',
          inTaxReceivable: '应收所得税',
          inTaxReceived: '已收所得税',
          vatSurchargeReceivable: '应收增值税及附加',
          vatSurchargeReceived: '已收增值税及附加',
          totalTaxNotCollected: '未收税金合计',
          projVat: '项目增值税税负',
          projInTax: '项目所得税税负',
          otherTax: '其他税费税负',
          totalTax: '整体税负'
        },
        searchInfo: {
          searchEntityId: '结算人',
          searchEntityIdPH: '请输入结算人',
          searchInvCollectUnitId: '收票单位',
          searchInvCollectUnitIdPH: '请输入收票单位',
          searchDocIndex: '凭证索引',
          searchDocIndexPH: '请选择凭证索引',
          searchInvNumber: '发票号码',
          searchInvNumberPH: '请输入发票号码',
          searchInvBillUnit: '开票单位',
          searchInvBillUnitPH: '请输入开票单位',
          searchInvAmt: '金额/小计',
          searchInvAmtPH: '请输入金额/小计',
          searchCertStatus: '认证状态',
          searchCertStatusPH: '请输入认证状态'
        },
        info: {
          invId: '发票ID',
          transId: '凭证',
          projId: '项目',
          compId: '公司',
          indDel: '标记删除',
          transDt: '凭证日期',
          entityId: '结算人',
          invCollectUnitId: '收票单位',
          invCollectUnitIdPH: '请输入收票单位',
          docIndex: '凭证索引',
          invCode: '发票代码',
          invCodePH: '请输入发票代码',
          invNumber: '发票号码',
          invNumberPH: '请输入发票号码',
          invDt: '开票日期',
          invDtPH: '请输入开票日期',
          invBillUnit: '开票单位',
          invBillUnitPH: '请输入开票单位',
          invContent: '开票内容',
          invContentPH: '请输入开票内容',
          invValueAmt: '金额',
          invValueAmtPH: '请输入金额',
          invDeductibleValue: '可抵税',
          indManualDeductibleValue: '手动调整',
          indManualDeductibleValuePH: '请输入',
          invDeductibleAmt: '可抵税额',
          invDeductibleAmtPH: '请输入可抵税额',
          invSubtotalAmt: '小计',
          invType: '类型',
          invTypePH: '请输入类型',
          invRate: '税率',
          invRatePH: '请输入税率',
          invPaymentType: '付款方式',
          invPaymentTypePH: '请输入付款方式',
          submitDt: '交票日期',
          submitDtPH: '请输入交票日期',
          certAmt: '认证税额',
          certAmtPH: '请输入认证税额',
          diffCertAmt: '认证税差额',
          remarks: '备注',
          remarksPH: '请输入备注'
        },
        validateInfo: {
          // transDtRequired: '日期必填',
          // feeIdRequired: '费用名称必填',
          // paymentIdRequired: '支付方式'
        }
      },
      projacctpaytrans: {
        moduleAlias: '凭证-应付账款栏',
        info: {
          transDt: '日期',
          transDtPH: '请输入日期',
          transSummary: '摘要',
          transSummaryPH: '请输入摘要',
          // // 资金-投资
          invest: '投资款',
          investPrincipal: '本金',
          investInAmt: '收入金额',
          investInAmtPH: '请输入收入金额',
          investOutAmt: '支出金额',
          investOutAmtPH: '请输入支出金额',
          investBalAmt: '本金余额',
          investBalAmtPH: '请输入本金余额',
          transIndex: '凭证索引',
          transIndexPH: '请输入凭证索引',
          transRemarks: '备注',
          transRemarksPH: '请输入备注'
        },
        validateInfo: {
          transDtRequired: '日期必填'
        }
      },
      projacctreceivetrans: {
        moduleAlias: '凭证-应收账款栏',
        info: {
          transDt: '日期',
          transDtPH: '请输入日期',
          transSummary: '摘要',
          transSummaryPH: '请输入摘要',
          // // 资金-投资
          invest: '投资款',
          investPrincipal: '本金',
          investInAmt: '收入金额',
          investInAmtPH: '请输入收入金额',
          investOutAmt: '支出金额',
          investOutAmtPH: '请输入支出金额',
          investBalAmt: '本金余额',
          investBalAmtPH: '请输入本金余额',
          transIndex: '凭证索引',
          transIndexPH: '请输入凭证索引',
          transRemarks: '备注',
          transRemarksPH: '请输入备注'
        },
        validateInfo: {
          transDtRequired: '日期必填'
        }
      },
      projacctcurtrans: {
        moduleAlias: '凭证-往来账款栏',
        info: {
          transDt: '日期',
          transDtPH: '请输入日期',
          transSummary: '摘要',
          transSummaryPH: '请输入摘要',
          // // 资金-投资
          invest: '投资款',
          investPrincipal: '本金',
          investInAmt: '收入金额',
          investInAmtPH: '请输入收入金额',
          investOutAmt: '支出金额',
          investOutAmtPH: '请输入支出金额',
          investBalAmt: '本金余额',
          investBalAmtPH: '请输入本金余额',
          transIndex: '凭证索引',
          transIndexPH: '请输入凭证索引',
          transRemarks: '备注',
          transRemarksPH: '请输入备注'
        },
        validateInfo: {
          transDtRequired: '日期必填'
        }
      },
      ctracct: {
        info: {
          acctName: '主体名称',
          acctNamePH: '请输入主体名称',
          acctDesc: '描述',
          acctDescPH: '请输入描述',
          acctContact: '联系方式',
          acctContactPH: '请输入联系方式'
        },
        button: {
          addBtn: '新增核算主体'
        },
        pageName: {
          addPage: '新增核算主体',
          editPage: '编辑核算主体',
          viewPage: '核算主体详情'
        },
        validateInfo: {
          acctNameRequired: '主体名称必填',
          compIdRequired: '所属公司必填',
          typeRequired: '主体类型必填',
          statusRequired: '状态必填'
        }
      }
    },
    loginPage: { // 登录页面
      title: '登 录 账 户',
      userName: '用户名',
      userNamePH: '输入您的用户名',
      password: '密码',
      passwordPH: '输入您的密码',
      verificationCode: '验证码',
      enterCode: '输入验证码',
      loginBtn: '登录',
      forgot: '忘记密码'
    },
    forgetPwdPage: {
      userName: '账号名称：',
      userNamePH: '请输入账号名称',
      changePasswordSuccess: '修改密码成功，请重新登录！',
      changePassword: '修改密码',
      enterOldPassword: '输入原密码：',
      enterOldPasswordPH: '请输入原密码',
      enterNewPassword: '输入新密码：',
      enterNewPasswordPH: '请输入新密码',
      confirmPassword: '确认新密码：',
      confirmPasswordPH: '请再次输入新密码',
      // mobile: '移动电话',
      // code: '验证码',
      validateInfo: {
        userNameRep: '账号名称必填',
        passwordReq: '密码必填',
        passwordLenLimit: '密码必须在6至16位之间',
        passwordNotEquals: '两次输入的密码不一致'
      },
      message: {
        canNotSame: '新旧密码不能一样'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js